export interface RolePermission {
  id: string,
  roleId: string,
  permission: Permission,
  operation: Operation
}

export enum Permission {
  Drawing,
  CommonDrawing,
  BuildKit,
  BuildKitSetting,
  BuildKitSettingTemplate,
  Traveler,
  CadModelRevisionQuantity,
  CadModel,
  CadModelRevision,
  CadModelRevisionDrawing,
  Project,
  Report,
  ReportTemplate,
  MaterialFamily,
  MaterialAlloy,
  MaterialType,
  MaterialTemper,
  MaterialGrade,
  MaterialProcess,
  MaterialSpecification,
  MaterialCondition,
  StockSizeShapeType,
  StockSizeShapeTypeMaterialAlloy,
  StockSizeShapeTypeMaterialFamily,
  ShapeType,
  CustomShape,
  Organization,
  Standard,
  Process,
  TravelerCategory,
  CotsType,
  CotsSubType,
  Role,
  User,
  MaterialSpecies,
  StockSizeShapeTypeMaterial,
  Material,
  UserInvite,
}

export enum Operation {
  Read,
  Create,
  Update,
  Delete,
  Download,
  Upload,
}
